export class DetalleVehiculoEntity {
    constructor(
        public CodigoUsuarioExtranet?: number,
        public CodigoProducto?: number,
        public CodigoCliente?: number,
        public CiudadCodigo?: number,
        public VehiculoCodigo?: number,
        public DuracionSeguro?: number,
        public MarcaVeh?: string,
        public ModeloVeh?: string,
        public VersionVeh?: string,
        public CodMarcaVeh?: number,
        public CodModeloVeh?: number,
        public CodVersionVeh?: number,
        public Color?: string,
        public Motor?: string,
        public Anio?: string,
        public TipoVeh?: string,
        public CodTipoVeh?: number,
        public Placa?: string,
        public Chasis?: string,
        public Actividad?: string,
        public ValorCasco?: number,
        public ValorExtras?: number,
        public Extras?: ExtrasEntity[],
        public ExtrasInclusion?: ExtrasEntity[],
        public InicioVigencia?: Date,
        public FinVigencia?: Date,
        public CodigoEjecutivoCuenta?: number,
        public CodigoProductoDeducible?: number,
        public CodigoVehiculoDeducible?: number,
        public CodigoCiudadDeducible?: number,
        public RenovarDeducible?: boolean,
        public EsDeducible?: boolean,
        public  Poliza ?: string,
        public  Propietario ?: string,
        public  CIPropietario ?: string,
        public Deducible?: boolean,
        public FormaPago?: FormaPagoEntity,
        public MantenerFormaPago?: boolean
    ) { }
}

export class ExtrasEntity {
    constructor(
        public CodExtra?: number,
        public NombreExtra?: string,
        public EstadoExtra?: number,
        public ValorExtra?: number,
        public Marca?: string,
        public Modelo?: string,
        public NombreExtraCod?: number
    ) { }
}

export class FormaPagoEntity{
    constructor(
    public  CuotaInicial ?: number,
    public  NumeroCuotas ?: number,
    public  CorteMes?: number,
    public  CodEntidadBancaria ?: number,
    public  EntidadBancaria ?: string,
    public  CodFormaPago ?: number,
    public  FormaPagoNombre ?: string,
    public  NumeroCtaTarjeta ?: string
){}
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/masivos/datosGenerales/entities/detalle_vehiculo_entity.ts